export default __webpack_public_path__ + "static/media/hír - 2021.10.02.684c029d.jpg";